import { getWorkOrderCategories, getWorkOrderCategory, updateWorkOrderCategory } from "@/api/workOrderCategories";
import { createStore } from "vuex";
import { WorkOrderCategoryState } from "../state";
import { WorkOrderCategory } from "../types";

export const workOrderCategoryStore = createStore({
  state: {
    workOrderCategories: [],
    workOrderCategory: {} as any,
    workOrderCategoryListTotal: 0,
    workOrderCategoryListLoading: false
  },
  getters: {
    workOrderCategories: (state: WorkOrderCategoryState) => state.workOrderCategories,
    workOrderCategory: (state: WorkOrderCategoryState) => state.workOrderCategory,
    workOrderCategoryListTotal: (state: WorkOrderCategoryState) => state.workOrderCategoryListTotal,
    workOrderCategoryListLoading: (state: WorkOrderCategoryState) => state.workOrderCategoryListLoading
  },
  mutations: {
    setWorkOrderCategories(state: WorkOrderCategoryState, payload: WorkOrderCategory[]) {
      state.workOrderCategories = payload
    },
    setWorkOrderCategory(state: WorkOrderCategoryState, payload: WorkOrderCategory) {
      state.workOrderCategory = payload
    },
    setWorkOrderCategoryListTotal(state: WorkOrderCategoryState, payload: number) {
      state.workOrderCategoryListTotal = payload
    },
    setWorkOrderCategoryListLoading(state: WorkOrderCategoryState, payload: boolean) {
      state.workOrderCategoryListLoading = payload
    }
  },
  actions: {
    async fetchWorkOrderCategories({ commit }, pagination) {
      commit('setWorkOrderCategoryListLoading', true)
      const response = await getWorkOrderCategories(pagination)
      commit('setWorkOrderCategories', response.data.data)
      commit('setWorkOrderCategoryListTotal', response.data.total)
      commit('setWorkOrderCategoryListLoading', false)
    },
    async fetchWorkOrderCategory({ commit }, id) {
      const response = await getWorkOrderCategory(id)
      commit('setWorkOrderCategory', response.data.data)
    },
    async updateWorkOrderCategory({ commit }, { id, data }) {
      const response = await updateWorkOrderCategory(id, data)
      commit('setWorkOrderCategory', response.data.data)
    }
  },
})

export default workOrderCategoryStore;
